module.exports = __webpack_public_path__ + "media/icons/inne_uslugi-18fd53c7.png";